import { Store, Globe, MapPin, Wifi, Bot, Users, Zap } from 'lucide-react';

// Sprint 40 — single source of truth for the 7-stage onboarding journey that
// used to be presented as two disconnected wizards (OnboardingWizard.js with
// its own 4-step tracker, then a hard navigate() into LeadAttendanceSetup.js
// with a SECOND, differently-styled 4-step tracker starting back at "1").
// Both files now render the same <OnboardingStepper> against this same list
// so the whole signup→attending-customers journey reads as one continuous
// flow instead of two separate products.
export const ONBOARDING_STAGES = [
  { key: 'negocio', title: 'Negocio', icon: Store },
  { key: 'detalles', title: 'Detalles', icon: Globe },
  { key: 'sede', title: 'Tu sede', icon: MapPin },
  { key: 'whatsapp', title: 'WhatsApp', icon: Wifi },
  { key: 'ai', title: 'Asistente IA', icon: Bot },
  { key: 'assignment', title: 'Equipo', icon: Users },
  { key: 'live_test', title: 'Prueba', icon: Zap },
];
